import ComparisonStatus from '../ComparisonStatus';

import useComparisonParams from '../../hooks/useComparisonParams';

import { getDateFromTimestamp } from '../../helpers';

import styles from './ComparisonSectionTitle.module.scss';

interface IComparisonSectionTitleProps {
  showStatus: boolean;
  isLeftVersion: boolean;
}

function ComparisonSectionTitle({ showStatus, isLeftVersion }: IComparisonSectionTitleProps) {
  const { leftEpochMillis, rightEpochMillis } = useComparisonParams();

  const date = getDateFromTimestamp(isLeftVersion ? leftEpochMillis : rightEpochMillis);

  return (
    <div className={styles.title}>
      <span className={styles.date}>{date}</span>
      {showStatus && <ComparisonStatus isLeftVersion={isLeftVersion} />}
    </div>
  );
}

export default ComparisonSectionTitle;
